import { InMemoryCache } from "@apollo/client";
import { layoutSettingsVar, globalSettingsVar } from "../apollo/local/cache";

const apolloCache = new InMemoryCache({
   addTypename: true,
   typePolicies: {
      Project: {
         //for reference
         keyFields: ["id"],
      },
      Query: {
         fields: {
            layoutSettings: {
               read() {
                  return layoutSettingsVar();
               },
            },
            globalSettings: {
               read() {
                  return globalSettingsVar();
               },
            },
            users: {
               merge(existing = [], incoming = []) {
                  return incoming;
               },
            },
         },
      },
   },
});

export default apolloCache;
